import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import axios from 'axios';
import { Constants } from '../../../endPoints';
import { useHistory } from 'react-router-dom';


export default function Countryslide() {

  const [countries, setCountries] = useState([]);
  const history = useHistory();

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await axios.get(`${Constants.listCounty}`);
        setCountries(response.data.data);
      } catch (error) {
        console.error('Error fetching countries:', error);
      }
    };
    fetchCountries();
  }, []);



  

    const settings = {
        dots: false,
        infinite: true,
        speed: 2000,
        autoplay: true, 
        autoplaySpeed: 1000,
        slidesToShow: 11,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 10,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 6,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow:3,
              slidesToScroll: 1,
            },
            
          },
        ],
    };
    const handleCountryClick = (countryId) => {
      const queryParams = new URLSearchParams();
      queryParams.append('country', countryId); // Add the country ID to the query params
      history.push(`/listing?${queryParams.toString()}`); // Redirect to the listing page with query parameters
    };
  

  return (
    <>
    <section className='py-10 md:block hidden'>
        <div className='container mx-auto px-4'>
        <Slider {...settings}>
          {countries.map((country) => (
            <div key={country.id} className='text-center' style={{ padding: '10px' }}>
              <a href='#' onClick={(e) => {
                  e.preventDefault(); // Prevent default link behavior
                  handleCountryClick(country.id); // Trigger navigation with country ID
                }} className='block'>
              <img className='m-auto w-10 h-10 object-cover rounded-full'
                        src={country.country_symbols}   title={country.country} style={{
                            width: '75px',
                            height: '75px',
                    }}/>
                <h2 className='mt-2 uppercase font-semibold text-[13px]'>{country.country}</h2>
              </a>
            </div>
          ))}
        </Slider>
        </div>
    </section>
    </>
  )
}
